/* eslint-disable */
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {KTCard, KTCardBody} from '../../../components'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'
import {
  edmGetSettings,
  selectEdmSettings,
  selectEdmSettingsLoading,
} from '../../../redux/slices/edmsettings.slice'
import {EdmSettingsForm} from './EdmSettingsForm'

function Index() {
  const dispatch = useDispatch()
  const settings = useSelector(selectEdmSettings)
  const loading = useSelector(selectEdmSettingsLoading)

  useEffect(() => {
    dispatch(edmGetSettings())
  }, [dispatch])

  return (
    <>
      <PageTitle>EDM Ayarları</PageTitle>
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='fw-bold'>EDM Bağlantı Ayarları</h3>
          </div>
        </div>
        <KTCardBody>
          {loading && <ListLoading />}
          {!loading && <EdmSettingsForm settings={settings} />}
        </KTCardBody>
      </KTCard>
    </>
  )
}

export {Index}
